export default __webpack_public_path__ + "707c5106b11252e37e791f5e52594b8c.png";